<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="modal-header">
  <h4 class="modal-title">
    <span *ngIf="currency && currency.id">{{ 'CURRENCIES.CURRENCIES_FORM.EDIT_CURRENCY' | translate }}</span>
    <span *ngIf="!currency || !currency.id">{{ 'CURRENCIES.CURRENCIES_FORM.ADD_CURRENCY' | translate }}</span>
  </h4>
  <button type="button" class="close btn-close-templates" aria-label="Close" (click)="modal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<ng-scrollbar class="modal-body ps">
  <form id="currency-form" (ngSubmit)="save()" [formGroup]="form" novalidate>
    <div class="form-group" *ngIf="currency && currency.id">
      <label>{{ 'CURRENCIES.CURRENCIES_FORM.NAME' | translate }}</label>
      <input type="text" class="form-control" formControlName="name" />
    </div>

    <div class="form-group">
      <label>{{ 'CURRENCIES.CURRENCIES_FORM.CODE' | translate }}</label>
      <input type="text" class="form-control" formControlName="code" />
    </div>

    <div class="form-group" *ngIf="currency && currency.id">
      <label>{{ 'CURRENCIES.CURRENCIES_FORM.SYMBOL' | translate }}</label>
      <input type="text" class="form-control" formControlName="symbol" />
    </div>

    <div class="form-group" *ngIf="currency && currency.id">
      <label>{{ 'CURRENCIES.CURRENCIES_FORM.FORMAT' | translate }}</label>
      <input type="text" class="form-control" formControlName="format" />
    </div>

    <div class="form-group" *ngIf="currency && currency.id">
      <label>{{ 'CURRENCIES.CURRENCIES_FORM.EXCHANGE_RATE' | translate }}</label>
      <input type="text" class="form-control" formControlName="exchange_rate" />
    </div>

    <div class="form-group" *ngIf="currency && currency.id">
      <label>{{ 'CURRENCIES.CURRENCIES_FORM.ORDER_INDEX' | translate }}</label>
      <input type="text" class="form-control" formControlName="order_index" />
    </div>

    <div class="form-group form-check" *ngIf="currency && currency.id">
      <input type="checkbox" class="form-check-input" formControlName="active" />
      <label class="form-check-label">{{ 'CURRENCIES.CURRENCIES_FORM.ACTIVE' | translate }}</label>
    </div>
  </form>
</ng-scrollbar>

<div class="modal-footer">
  <button type="submit" class="btn btn-outline-dark btn-xs" form="currency-form" [disabled]="form.invalid">
    {{ 'CURRENCIES.CURRENCIES_FORM.SAVE' | translate }}
  </button>
</div>
